// extracted by mini-css-extract-plugin
module.exports = {"form-container":"Form_form-container__1U40v","form":"Form_form__2EjEr","form-input":"Form_form-input__ri8u5","form-btn":"Form_form-btn__3goT7"};